import { ReactNode } from 'react';

// A row of badges acting as toggles. An empty selection means "no filter"
// rather than "match nothing", so the row starts showing everything.
const BadgeFilterRow = ({
  label,
  options,
  selected,
  onToggle,
  onClear,
  renderBadge
}: {
  label: string;
  options: readonly string[];
  selected: Set<string>;
  onToggle: (option: string) => void;
  onClear: () => void;
  renderBadge: (option: string) => ReactNode;
}) => (
  <div className="flex items-center gap-2 flex-wrap">
    <span className="text-xs text-gray-500">{label}:</span>
    {options.map((option) => (
      <button
        key={option}
        type="button"
        className={`cursor-pointer ${selected.has(option) ? '' : 'opacity-40'}`}
        onClick={() => onToggle(option)}>
        {renderBadge(option)}
      </button>
    ))}
    {selected.size > 0 && (
      <button
        type="button"
        className="text-xs text-gray-500 hover:text-gray-700 underline"
        onClick={onClear}>
        clear
      </button>
    )}
  </div>
);

export default BadgeFilterRow;
